export default [
  {
    path: "/userlist",
    name: "userlist",
    component: () => import(/* webpackChunkName: "account" */ "../views/user/vUserList.vue"),
    meta: { title: "Users", auth: true, roles: [10, 20] },
  },

];
